import { render, staticRenderFns } from "./Planograma.vue?vue&type=template&id=275adbdf&scoped=true&"
import script from "./Planograma.vue?vue&type=script&lang=js&"
export * from "./Planograma.vue?vue&type=script&lang=js&"
import style0 from "./Planograma.vue?vue&type=style&index=0&id=275adbdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275adbdf",
  null
  
)

component.options.__file = "Planograma.vue"
export default component.exports